import { shallowMount } from "@vue/test-utils";
import ProductContainer from "@/components/core/ProductContainer";

describe("ProductContainer Component mount", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ProductContainer, {
      props: {
        title: "title"
      }
    });
  });

  it("Renders del component ProductContainer", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
